import { render, staticRenderFns } from "./HttpError.vue?vue&type=template&id=018aa7aa&"
import script from "./HttpError.vue?vue&type=script&lang=js&"
export * from "./HttpError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports